__turbopack_context__.v({
  "dl": "SupportContactCard-module__StHJqq__dl",
  "link": "SupportContactCard-module__StHJqq__link",
  "root": "SupportContactCard-module__StHJqq__root",
  "title": "SupportContactCard-module__StHJqq__title",
});
